import { View } from 'react-native'
import { useState } from 'react'
import Page from '@shell/Page'

import ModalWide from '@ui/components/Modal/variants/ModalWide'
import Header from '@ui/elements/Header'
import SectionRow from '@ui/elements/SectionRow'
import { borderRadius } from '@ui/elements/SectionRow/styles'

const sGroup =
  'relative inset-0 flex w-full flex-col gap-0 border border-black/10 overflow-hidden'

export default function DevFormsModals() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Page stage="payment">
        <Header
          title="Forms Modals"
          desc="View example form input form divided into sections and modals."
        />
        <View className="flex items-center justify-start gap-8 px-8 pb-16">
          <View className={sGroup} style={{ borderRadius }}>
            <SectionRow
              icon="user-circle"
              variant="default"
              title="Identity & Personal Details"
              desc="Provide personal data for verification and contact purposes."
              index={0}
              isGrouped
            />
            <SectionRow
              icon="home-2"
              variant="default"
              title="Residence Address"
              desc="Address details of your current place of residence."
              isGrouped
            />
            <SectionRow
              icon="briefcase"
              variant="default"
              title="Employment Information"
              desc="Provide employment details for financial eligibility assessment."
              isGrouped
            />
            <SectionRow
              icon="coin"
              variant="default"
              title="Bank Account Details"
              desc="Banking information and payment preferences."
              isGrouped
            />
            <SectionRow
              icon="file-invoice"
              variant="default"
              title="Terms & Policies"
              desc="Review legal disclosures and policy agreements."
              isGrouped
            />
          </View>
          <View className={sGroup} style={{ borderRadius }}>
            <SectionRow
              icon="user-circle"
              variant="default"
              title="Identity & Personal Details"
              desc="Provide personal data for verification and contact purposes."
              index={0}
              isGrouped
            />
            <SectionRow
              icon="home-2"
              variant="success"
              title="Residence Address"
              // desc="Address details of your current place of residence."
              info="required fields filled"
              isGrouped
            />
            <SectionRow
              icon="briefcase"
              variant="success"
              title="Employment Information"
              // desc="Provide employment details for financial eligibility assessment."
              info="completed"
              isGrouped
            />
            <SectionRow
              icon="coin"
              variant="default"
              title="Bank Account Details"
              desc="Banking information and payment preferences."
              isGrouped
            />
            <SectionRow
              icon="file-invoice"
              variant="danger"
              title="Terms & Policies"
              desc="Review legal disclosures and policy agreements."
              info="invalid 2 fields"
              isGrouped
            />
          </View>
          <View className={sGroup} style={{ borderRadius }}>
            <SectionRow
              icon="user-circle"
              variant="default"
              title="Identity & Personal Details"
              desc="Provide personal data for verification and contact purposes."
              index={0}
              isGrouped
            />
            <SectionRow
              icon="home-2"
              variant="success"
              title="Residence Address"
              // desc="Address details of your current place of residence."
              info="required fields filled"
              isGrouped
            />
            <SectionRow
              icon="briefcase"
              variant="success"
              title="Employment Information"
              // desc="Provide employment details for financial eligibility assessment."
              info="completed"
              isGrouped
            />
            <SectionRow
              icon="coin"
              variant="danger"
              title="Bank Account Details"
              desc="Banking information and payment preferences."
              isGrouped
            />
            <SectionRow
              icon="file-invoice"
              variant="danger"
              title="Terms & Policies"
              desc="Review legal disclosures and policy agreements."
              info="invalid 2 fields"
              isGrouped
            />
          </View>
        </View>
      </Page>
      <ModalWide
        open={open}
        close={() => setOpen(false)}
        body={<View className="gap-8 p-16"></View>}
      />
    </>
  )
}
